// animated-counter.component.ts
import { Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-animated-counter',
  templateUrl: './animated-counter.component.html',
  styleUrls: ['./animated-counter.component.scss'],
  standalone:false
})
export class AnimatedCounterComponent implements OnChanges {
  @Input() number: number = 0;
  digits: number[] = [];

  ngOnChanges() {
    this.digits = this.number.toString().split('').map(Number);
  }

  getTranslateValue(digit: number): string {
    return `-${digit}em`;
  }

  getDelay(index: number): string {
    return `${index * 0.2}s`;
  }
}